// The applicant's side of the founding developers application on the dashboard (docs/build/founding-devs.md): its
// status, the note a moderator left, and the new addresses being added to the catalogue. Hidden for anyone who
// hasn't applied, and on an accounts without the route. The applicant never sees a ranking.

import { api } from "../api.ts";
import { dayText, domainOf, foundingLine, replyBy, STATUS_COPY, URL_STATE, type MyApplication } from "../dev-apply.ts";
import { clear, h, link } from "../dom.ts";

export function applicationPanel(): HTMLElement {
  const el = h("section", { class: "panel dev-app", hidden: true });
  void api<MyApplication>("accounts", "/dev-applications/me")
    .then((mine) => {
      const a = mine.application;
      if (!a) return; // not applied
      const copy = STATUS_COPY[a.status];
      const count = foundingLine(mine.cohort);
      clear(
        el,
        h("p", { class: "dev-app-kicker" }, "Founding developers ", h("span", { class: `badge ${a.status === "approved" ? "ok" : a.status === "declined" ? "" : "warn"}` }, copy.badge)),
        h("h2", null, copy.title),
        h("p", null, a.status === "submitted" ? `You'll hear from us by ${dayText(replyBy(a.createdAt))}. ` : "", copy.body),
        a.note && a.status !== "submitted" ? h("blockquote", { class: "dev-app-note" }, a.note) : null,
        a.urls.length
          ? h(
              "ul",
              { class: "dev-app-urls" },
              a.urls.map((u) =>
                h(
                  "li",
                  null,
                  u.listed ? link(`/g/${u.listed.gameId}`, null, u.listed.title) : h("span", { class: "dev-app-domain" }, domainOf(u.url)),
                  h("span", { class: `badge ${u.state === "listed" ? "ok" : u.state === "being_added" ? "warn" : ""}` }, URL_STATE[u.state] ?? u.state),
                ),
              ),
            )
          : null,
        count ? h("p", { class: "dim small" }, count) : null,
        a.status === "waitlisted" ? link("/haunt", { class: "btn small ghost" }, "Open Haunt") : null,
      );
      el.hidden = false;
    })
    .catch(() => {});
  return el;
}
